export const races = [
  {
    name: 'Orc',
    img: '/assets/img/game_resources/racas/orc.png',
    pv: 30,
    ph: 2,
    mov: 3,
    str: 9,
    res: 8,
    dex: 6,
    agi: 6,
    wis: 2,
    int: 3,
    skills: [
      {
        name: 'Músculos de Ferro',
        type: 'atk',
        desc: 'Pode ser ativada uma vez na batalha. Dano + 2.'
      },

      {
        name: 'Músculos de Aço',
        type: 'atk',
        desc: 'Pode ser ativada uma vez na batalha. Dano + 3.'
      },

      {
        name: 'Presença Aterrorizante',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. O alvo deve estar no máximo a 5 quadrados de distância. Todos os atributos do alvo são reduzidos em 2 pontos enquanto esse personagem estiver vivo.'
      },

      {
        name: 'Frenesi',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Dura 3 rodadas. Ataca o alvo mais próximo (não importando distância ou se é aliado ou inimigo). Dano +5 e ganha um ataque adicional por turno.'
      }
    ]
  },

  {
    name: 'Elfo',
    img: '/assets/img/game_resources/racas/elfo.png',
    pv: 20,
    ph: 7,
    mov: 3,
    str: 2,
    res: 2,
    dex: 6,
    agi: 5,
    wis: 9,
    int: 10,
    skills: [
      {
        name: 'Visão Certeira',
        type: 'atk',
        desc: 'Pode ser ativada duas vezes na batalha. Dano e Alcance + 1.'
      },

      {
        name: 'Passo das Folhas',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Teletransporta para qualquer local do campo de batalha e Dano + 2 na próxima rodada'
      },

      {
        name: 'Invocar Poder da Natureza',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Escolhe um: Altera o clima do campo de batalha para um clima aleatório OU Altera o horário do campo de batalha para um horário aleatório OU Altera todo o terreno do campo de batalha'
      },

      {
        name: 'Entrar em Transe',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Fica a próxima rodada sem fazer nenhuma ação e recupera PV e PH por completo'
      }
    ]
  },

  {
    name: 'Demônio',
    img: '/assets/img/game_resources/racas/demonio.png',
    pv: 27,
    ph: 3,
    mov: 3,
    str: 10,
    res: 5,
    dex: 2,
    agi: 3,
    wis: 5,
    int: 9,
    skills: [
      {
        name: 'Insanidade das Trevas',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. Dano + 5 no próximo ataque feito e recebido.'
      },

      {
        name: 'Invocar Escuridão',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Muda o horário do campo de batalha para “Noite” e o clima para “Neblina” durante 3 rodadas.'
      },

      {
        name: 'Aura do Medo',
        type: 'pas',
        desc:
          'Toda vez que um ataque causar mais de 5 pontos de dano joga 1d6, se o resultado for 6 o alvo fica paralisado durante a próxima rodada.'
      },

      {
        name: 'Aura de Destruição',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Transforma uma área de 5x5 - sendo o centro o usuário - em “Deserto”, empurra todos outros personagens para fora da área e causa 2d6 de dano a cada um'
      }
    ]
  },

  {
    name: 'Tritão',
    img: '/assets/img/game_resources/racas/tritao.png',
    pv: 23,
    ph: 5,
    mov: 3,
    str: 3,
    res: 4,
    dex: 8,
    agi: 8,
    wis: 6,
    int: 5,
    skills: [
      {
        name: 'Perícia Aquática',
        type: 'pas',
        desc:
          'Enquanto esse personagem estiver em um terreno aquático: Mov + 1.'
      },

      {
        name: 'Afogar',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Transforma uma área de 3x3 - sendo o centro o usuário - em “Água Rasa” e joga 1d6 se o resultado for 5 transforma a “Água Rasa” em “Água Mediana” e se for 6 transforma em “Água Funda”. A água segue esse personagem durante 3 rodadas. Se algum personagem que não conseguir ficar naquele terreno entrar em contato com a água leva 1 ponto de dano e caso permaneça na água, não pode se movimentar.'
      },

      {
        name: 'Essência Aquática',
        type: 'pas',
        desc:
          'Enquanto esse personagem estiver em um terreno aquático: Dano e Defesa + 2.'
      },

      {
        name: 'Invocar Dilúvio',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Transforma todo o campo de batalha em Água durante 3 rodadas: Uma em “Água Funda”, uma em “Água Mediana” e uma em “Água Rasa”. Todos personagens que não puderem ficar no terreno ficam desmaiados enquanto estiverem no terreno.'
      }
    ]
  },

  {
    name: 'Zumbi',
    img: '/assets/img/game_resources/racas/zumbi.png',
    pv: 26,
    ph: 2,
    mov: 3,
    str: 9,
    res: 9,
    dex: 6,
    agi: 5,
    wis: 2,
    int: 3,
    skills: [
      {
        name: 'Investida Raivosa',
        type: 'atk',
        desc: 'Pode ser ativada uma vez na batalha. Alcance + 2 e Dano + 2.'
      },

      {
        name: 'Resistência do Além',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Defesa + 3 durante 3 rodadas.'
      },

      {
        name: 'Comer Cérebro',
        type: 'pas',
        desc:
          'Toda vez que um oponente morrer por um ataque e/ou habilidade desse personagem. Dano e Defesa + 1 durante toda a batalha.'
      },

      {
        name: 'Toque da Morte',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Envenena o alvo por 2 rodadas. Joga 1d6, se o resultado for 5 envenena o alvo pelo resto da batalha e se for 6 mata o alvo instantaneamente.'
      }
    ],
    special: {
      value: 3,
      name: 'Renascimento Sombrio',
      type: 'pas',
      desc:
        'Toda vez que esse personagem morrer joga 1d6, se o resultado for 6 revive com PV = 15.'
    }
  },

  {
    name: 'Centauro',
    img: '/assets/img/game_resources/racas/centauro.png',
    pv: 26,
    ph: 4,
    mov: 4,
    str: 8,
    res: 5,
    dex: 7,
    agi: 9,
    wis: 2,
    int: 3,
    skills: [
      {
        name: 'Corrida Furiosa',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. Mov + 2 durante duas rodadas.'
      },

      {
        name: 'Devastar',
        type: 'atk',
        desc:
          'Pode ser ativada uma vez na batalha. Joga 1d6 se o resultado for um número ímpar: Dano + 2 e arremessa o alvo 2 quadrados para trás. Se o resultado for um número par: Deixa o alvo paralisado durante uma rodada.'
      },

      {
        name: 'Pisotear',
        type: 'atk',
        desc:
          'Pode ser ativada uma vez na batalha. Dano + 3. Se o alvo estiver a 3 ou 4 quadrados de distância joga 1d6 e se o resultado for um número par arremessa o alvo 2 quadrados para trás e Dano + 1.'
      },

      {
        name: 'Investida Épica',
        type: 'atk',
        desc:
          'Pode ser ativada uma vez na batalha. Apenas pode ser utilizado em um oponente entre 3 e 5 quadrados de distância. Dano + 4 e arremessa o alvo 3 quadrados para trás. Joga 1d6 se o resultado for um número ímpar Dano + 1 e o alvo fica paralisado por uma rodada.'
      }
    ]
  },

  {
    name: 'Dragoon',
    img: '/assets/img/game_resources/racas/dragoon.png',
    pv: 30,
    ph: 7,
    mov: 3,
    str: 9,
    res: 10,
    dex: 3,
    agi: 2,
    wis: 5,
    int: 5,
    skills: [
      {
        name: 'Escamas de Dragão',
        type: 'pas',
        desc: 'Defesa + 1 contra ataques a distância que não sejam magias.'
      },

      {
        name: 'Músculos de Aço',
        type: 'atk',
        desc: 'Pode ser ativada uma vez na batalha. Dano + 3.'
      },

      {
        name: 'Essência Dracônica',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Transforma em um Dragão Mediano por 2 rodadas: Mov + 1, Dano + 2, Defesa + 3.'
      },

      {
        name: 'Rajada do Dragão',
        type: 'atk',
        desc:
          'Pode ser ativada uma vez na batalha. Realiza um ataque em cone (1-3-5), Dano + 4 e joga 1d6. Se o resultado for 5 ou 6 deixa todos que foram atingidos queimando por 2 rodadas.'
      }
    ]
  },

  {
    name: 'Ninfa',
    img: '/assets/img/game_resources/racas/ninfa.png',
    pv: 15,
    ph: 8,
    mov: 3,
    str: 1,
    res: 1,
    dex: 7,
    agi: 6,
    wis: 9,
    int: 10,
    skills: [
      {
        name: 'Beleza Cegante',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. O alvo deve estar a, no máximo, 3 quadrados de distância. O alvo deve jogar 1d20 antes de atacar, caso o resultado seja menor que 8, o próximo ataque falha.'
      },

      {
        name: 'Cavalgar Sereno',
        type: 'atk',
        desc:
          'Pode ser ativada duas vezes na batalha. Mov + 2 na próxima rodada e joga 1d6, se o resultado for 5 ou 6, Dano + 2.'
      },

      {
        name: 'Comungar com a Natureza',
        type: 'pas',
        desc:
          'Enquanto esse personagem estiver em um campo aquático ou em uma “Floresta”: Defesa + 1 e recupera 5 PV por rodada.'
      },

      {
        name: 'Fantoche Apaixonado',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. O alvo deve estar a, no máximo, 3 quadrados de distância. O alvo deve jogar 1d20, caso o resultado seja menor que 15, a Ninfa controla o personagem durante a próxima rodada.'
      }
    ]
  },

  {
    name: 'Lobisomem',
    img: '/assets/img/game_resources/racas/lobisomem.png',
    pv: 40,
    ph: 2,
    mov: 3,
    str: 9,
    res: 7,
    dex: 7,
    agi: 9,
    wis: 1,
    int: 1,
    skills: [
      {
        name: 'Músculos de Ferro',
        type: 'atk',
        desc: 'Pode ser ativada uma vez na batalha. Dano + 2.'
      },

      {
        name: 'Patada Brutal',
        type: 'atk',
        desc:
          'Pode ser ativada duas vezes na batalha. Dano + 2 e arremessa o alvo 2 quadrados para trás.'
      },

      {
        name: 'Presas de Aço',
        type: 'pas',
        desc:
          'O lobisomem pode atacar a qualquer momento com sua mordida ao invés de sua arma. O bônus de ataque permanece igual ao da arma. Se o dano for maior que 5 joga 1d6, se der 5 ou 6 causa sangramento.'
      },

      {
        name: 'Uivo Sinistro',
        type: 'sup',
        desc:
          'Pode ser ativado uma vez por batalha. Todos no campo de batalha que não forem da raça lobisomem tem todos os atributos diminuídos em 3 pontos por 2 rodadas, ficam 1 rodada sem fazer nenhuma ação. Mov + 2 durante 1 rodada e muda o horário do campo de batalha para “Noite” por 2 rodadas.'
      }
    ],
    special: {
      value: 3,
      name: 'Resistência Épica',
      type: 'pas',
      desc: 'Defesa + 2 (exceto se atacado por magias e armas lendárias).'
    }
  },

  {
    name: 'Gnomo',
    img: '/assets/img/game_resources/racas/gnomo.png',
    pv: 12,
    ph: 7,
    mov: 3,
    str: 2,
    res: 2,
    dex: 6,
    agi: 9,
    wis: 9,
    int: 6,
    skills: [
      {
        name: 'Trapacear em Ataque',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. Pode ser ativada depois de calcular o dano do ataque. Se o dano causado pelo ataque desse personagem for menor que 3. Dano + 2 no próximo ataque.'
      },

      {
        name: 'Passo das Sombras',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Teletransporta para qualquer lugar do campo de batalha e Mov e Defesa + 1 durante 2 rodadas.'
      },

      {
        name: 'Camuflagem Perfeita',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. Deixa invisível por 2 rodadas.'
      },

      {
        name: '"O Elixir"',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Transforma esse personagem em tamanho de um Gigante. Dano e Defesa + 4 durante 3 rodadas. Enquanto estiver sob efeito dessa habilidade, não pode utilizar outras habilidades de Raça.'
      }
    ]
  },

  {
    name: 'Vampiro',
    img: '/assets/img/game_resources/racas/vampiro.png',
    pv: 28,
    ph: 7,
    mov: 3,
    str: 5,
    res: 3,
    dex: 3,
    agi: 8,
    wis: 9,
    int: 6,
    skills: [
      {
        name: 'Força Milenar',
        type: 'atk',
        desc:
          'Pode ser ativada duas vezes na batalha. Arremessa o alvo 2 quadrados para trás e Dano + 1.'
      },

      {
        name: 'Reflexo no Espelho',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Joga 1d6, se o resultado for um número par, fica 2 rodadas invisível e se o resultado for um número ímpar fica 1 rodada invisível.'
      },

      {
        name: 'Velocidade Suprema',
        type: 'pas',
        desc:
          'Mov + 1 e duas vezes na batalha pode se movimentar para qualquer lugar do campo de batalha.'
      },

      {
        name: 'Drenar Sangue',
        type: 'pas',
        desc:
          'Recupera o PV numa quantidade igual à metade de todo dano causado aos inimigos arredondado para baixo, podendo ultrapassar o total de PV do personagem.'
      }
    ],
    special: {
      value: 3,
      name: 'Existência Vampírica',
      type: 'pas',
      desc:
        'Defesa + 2 (exceto se atacado por magias e armas lendárias). Se o horário de batalha não for “Tarde”: quando PV chegar a 0, fica inconsciente (Todos atributos - 5). Se em três rodadas não for causado 15 pontos de dano nesse personagem ele revive com PV = 15.'
    }
  },

  {
    name: 'Harpia',
    img: '/assets/img/game_resources/racas/harpia.png',
    pv: 25,
    ph: 4,
    mov: 3,
    str: 5,
    res: 2,
    dex: 9,
    agi: 10,
    wis: 3,
    int: 5,
    skills: [
      {
        name: 'Esquivar',
        type: 'def',
        desc:
          'Pode ser ativada duas vezes na batalha. Joga 1d6 e se o resultado for 6, pode esquivar-se do ataque.'
      },

      {
        name: 'Rajada de Vento',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Arremessa todos personagens em uma área de 5x5 - com o centro sendo esse personagem - para fora dessa área e causa 2 pontos de dano.'
      },

      {
        name: 'Grito Atordoante',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Todos os outros personagens no campo de batalha ficam 2 rodadas com todos atributos -2.'
      },

      {
        name: 'Voo Colossal',
        type: 'atk',
        desc:
          'Pode ser ativada uma vez na batalha. Agarra o oponente e voa até a estratosfera, volta em espiral e arremessa o oponente na terra. Dano +6 e joga 1d6, se o resultado for um número par o oponente fica desmaiado por 2 rodadas, e se o resultado for um número ímpar o oponente fica sangrando por 3 rodadas.'
      }
    ]
  },

  {
    name: 'Anão',
    img: '/assets/img/game_resources/racas/anao.png',
    pv: 30,
    ph: 3,
    mov: 2,
    str: 9,
    res: 9,
    dex: 3,
    agi: 2,
    wis: 5,
    int: 6,
    skills: [
      {
        name: 'Descanso Merecido',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. Fica um turno sem fazer nenhuma ação e recupera 10 PV.'
      },

      {
        name: 'Lealdade Única',
        type: 'pas',
        desc:
          'Enquanto todos os aliados estiverem com PV menor ou igual a 15: Dano e Defesa + 2.'
      },

      {
        name: 'Ataque Final',
        type: 'def',
        desc:
          'Pode ser ativada uma vez na batalha. Pode ser ativada no turno do oponente depois de calcular o dano do ataque. Se o ataque for matar este personagem, realiza primeiro um ataque com Dano + 10.'
      },

      {
        name: 'Revestimento de Ouro',
        type: 'pas',
        desc:
          'Ganha uma versão da arma e armadura revestida de ouro. Pode trocar elas durante sua rodada, gastando uma ação de movimento. Dano + 4, Defesa + 3, Mov = 1 enquanto estiver usando os equipamentos de ouro.'
      }
    ]
  },

  {
    name: 'Humano',
    img: '/assets/img/game_resources/racas/humano.png',
    pv: 23,
    ph: 3,
    mov: 3,
    str: 7,
    res: 5,
    dex: 5,
    agi: 5,
    wis: 5,
    int: 7,
    skills: [
      {
        name: 'Resistir à Dor',
        type: 'def',
        desc:
          'Pode ser ativada duas vezes na batalha. Defesa + 2 durante 1 rodada.'
      },

      {
        name: 'Vontade de Viver',
        type: 'def',
        desc:
          'Pode ser ativada uma vez na batalha. Quando o personagem morrer, joga 1d6, se o resultado for 6 o PV volta para 50% do total.'
      },

      {
        name: 'Caçada Mortal',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Mov + 1 durante 2 rodadas e marca um oponente no tabuleiro, Dano e Defesa + 2 contra o oponente marcado.'
      },

      {
        name: 'Supremacia',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Dano e Defesa + 5 contra oponentes de outras raças durante 3 rodadas.'
      }
    ]
  },

  {
    name: 'Fada',
    img: '/assets/img/game_resources/racas/fada.png',
    pv: 12,
    ph: 8,
    mov: 4,
    str: 1,
    res: 1,
    dex: 7,
    agi: 6,
    wis: 9,
    int: 10,
    skills: [
      {
        name: 'Ajuda Mágica',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. O alvo deve estar a no máximo 3 quadrados de distância: Dano e Defesa + 2 do alvo durante 1 rodada.'
      },

      {
        name: 'Esconderijo Mágico',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Fica invisível durante 1 rodada e recupera 10 PV.'
      },

      {
        name: 'Comungar com a Natureza',
        type: 'pas',
        desc:
          'Enquanto esse personagem estiver em um campo aquático ou em uma “Floresta”: Defesa + 1 e recupera 5 PV por rodada.'
      },

      {
        name: 'Pó Misterioso',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez por batalha. Joga 1d6, se o resultado for 1 ou 2 o alvo fica paralisado 2 rodadas, se o resultado for entre 3 e 5 o alvo fica envenenado pelo resto da batalha e se o resultado for 6 o alvo morre em 3 rodadas.'
      }
    ],
    special: {
      value: 2,
      name: 'Tamanho Excepcional',
      type: 'pas',
      desc:
        'Quando está sendo atacado por um oponente das raças: Gigante ou Orc, joga 1d6, se o resultado for 5 ou 6 o ataque falha.'
    }
  },

  {
    name: 'Nagah',
    img: '/assets/img/game_resources/racas/nagah.png',
    pv: 25,
    ph: 4,
    mov: 3,
    str: 8,
    res: 3,
    dex: 3,
    agi: 8,
    wis: 6,
    int: 6,
    skills: [
      {
        name: 'Bote',
        type: 'atk',
        desc:
          'Pode ser ativada uma vez na batalha. O alvo pode estar até a 4 quadrados de distância. Dano + 1 e joga 1d6, se o resultado for 6, envenena o alvo por 2 rodadas.'
      },

      {
        name: 'Trocar de Pele',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Recupera 10 PV e remove todos status negativos. Não pode ter se movimentado para usar essa habilidade.'
      },

      {
        name: 'Sangue Venenoso',
        type: 'pas',
        desc:
          'Toda vez que o dano sofrido for maior que 3, o oponente joga 1d6, se o resultado for 1 ou 2 fica envenenado por 2 rodadas.'
      },

      {
        name: 'Toca da Morte',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Cria um túnel para qualquer lugar do campo de batalha (exceto campos aquáticos e “Montanha”) e envolve o alvo durante 2 rodadas. Enquanto o alvo estiver envolvido, não pode atacar. Dano + 4 enquanto estiver envolvendo o alvo. Quando soltar o alvo, joga 1d6, se o resultado for 1 ou 6, envenena o alvo pelo resto da batalha.'
      }
    ],
    special: {
      value: 2,
      name: 'Imunidade à Veneno',
      type: 'pas',
      desc: 'Esse personagem não pode ser envenenado.'
    }
  },

  {
    name: 'Gigante',
    img: '/assets/img/game_resources/racas/gigante.png',
    pv: 42,
    ph: 2,
    mov: 3,
    str: 10,
    res: 10,
    dex: 2,
    agi: 2,
    wis: 5,
    int: 5,
    skills: [
      {
        name: 'Músculos de Aço',
        type: 'atk',
        desc: 'Pode ser ativada uma vez na batalha. Dano + 3.'
      },

      {
        name: 'Ataque Distante',
        type: 'pas',
        desc: 'Aumenta o Alcance do Ataque em 1 quadrado.'
      },

      {
        name: 'Presença Atordoante',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Todos os personagens em uma área de 5x5 - com o centro sendo esse personagem - tem todos os status reduzidos em 2 pontos durante 3 rodadas e não podem fazer nenhuma ação durante 1 rodada.'
      },

      {
        name: 'Vale da Morte',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Cria uma fenda cruzando o campo de batalha em uma direção, onde personagens que não são da raça “Gigante” ou que não voam, ao tentar cruzar essa fenda, jogam 1d20. Se o resultado for menor que 15 caem na fenda. Quando um personagem cai na fenda, ele fica 3 rodadas sangrando e sem fazer nenhuma ação.'
      }
    ]
  },

  {
    name: 'Fantasma',
    img: '/assets/img/game_resources/racas/fantasma.png',
    pv: 22,
    ph: 7,
    mov: 3,
    str: 2,
    res: 2,
    dex: 6,
    agi: 7,
    wis: 9,
    int: 8,
    skills: [
      {
        name: 'Toque Macabro',
        type: 'atk',
        desc:
          'Pode ser ativada uma vez na batalha. Os atributos do alvo são reduzidos em 2 pontos por 1 rodada. Joga 1d6, se o resultado for 6 o alvo fica paralisado por 1 rodada após acabar o efeito da redução dos atributos.'
      },

      {
        name: 'Presença Aterrorizante',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. O alvo deve estar no máximo a 5 quadrados de distância. Todos os atributos do alvo são reduzidos em 2 pontos enquanto esse personagem estiver vivo.'
      },

      {
        name: 'Possuir Corpo',
        type: 'atk',
        desc:
          'Pode ser ativada duas vezes na batalha. Pode entrar no corpo de qualquer oponente no campo de batalha e controlá-lo por 1 rodada.'
      },

      {
        name: 'Presença Macabra',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Todos os atributos de todos oponentes são reduzidos em 2 pontos enquanto esse personagem estiver vivo. Paralisa todos oponentes por 2 rodadas e Dano + 3 por 2 rodadas.'
      }
    ],
    special: {
      value: 3,
      name: 'Passo Fantasmagórico',
      type: 'pas',
      desc:
        'Pode mover livremente no campo de batalha, passando dentro dos outros personagens. Toda vez que passar dentro de um personagem joga 1d6, se o resultado for 5 ou 6 os atributos do personagem são reduzidos em 1 ponto por 1 rodada.'
    }
  },

  {
    name: 'Anjo',
    img: '/assets/img/game_resources/racas/anjo.png',
    pv: 30,
    ph: 7,
    mov: 3,
    str: 2,
    res: 7,
    dex: 8,
    agi: 3,
    wis: 7,
    int: 7,
    skills: [
      {
        name: 'Aura Celestial',
        type: 'sup',
        desc:
          'Pode ser ativada duas vezes na batalha. Recupera 5 PV e Mov + 1 durante 1 rodada.'
      },

      {
        name: 'Aura Pacífica',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Escolhe um oponente no campo de batalha e joga 1d6, se o resultado for entre 2 e 5 o alvo fica sem atacar durante 1 rodada, e se o resultado for 1 ou 6 o alvo fica sem atacar durante 2 rodadas.'
      },

      {
        name: 'Aura de Justiça',
        type: 'atk',
        desc:
          'Pode ser ativada duas vezes na batalha. Pode realizar um ataque em qualquer lugar do campo de batalha.'
      },

      {
        name: 'Invocar Paraíso',
        type: 'sup',
        desc:
          'Pode ser ativada uma vez na batalha. Tem de ser usado sem ter se movido. Todo o terreno do campo de batalha se torna “Grama”. Muda o horário do campo de batalha para “Tarde”, muda o clima para “Ensolarado”. Dano e Defesa + 3 e recupera 5 PV durante 3 rodadas.'
      }
    ]
  },

  {
    name: 'Doppelganger',
    img: '/assets/img/game_resources/racas/doppelganger.png',
    pv: 30,
    ph: 5,
    mov: 3,
    str: 6,
    res: 6,
    dex: 6,
    agi: 6,
    wis: 6,
    int: 6,
    special: {
      value: 1,
      name: 'Metamorfose',
      type: 'pas',
      desc:
        'No início de todo turno o Doppelganger pode se tornar uma cópia de qualquer raça do campo de batalha, adquirindo seus atributos de raça e as habilidades de raça (conforme nível desse personagem), mas não pode adquirir a habilidade especial da raça caso ela tenha.'
    }
  }
]

export const raceLevels = [
  {
    name: 'Iniciante',
    value: 1,
    pv: -2,
    ph: -1,
    mov: -1,
    str: -1,
    res: -1,
    dex: -1,
    agi: -1,
    wis: -1,
    int: -1
  },

  {
    name: 'Normal',
    value: 2,
    pv: 0,
    ph: 0,
    mov: 0,
    str: 0,
    res: 0,
    dex: 0,
    agi: 0,
    wis: 0,
    int: 0
  },

  {
    name: 'Normal',
    value: 2,
    pv: 0,
    ph: 0,
    mov: 0,
    str: 0,
    res: 0,
    dex: 0,
    agi: 0,
    wis: 0,
    int: 0
  },

  {
    name: 'Normal',
    value: 2,
    pv: 0,
    ph: 0,
    mov: 0,
    str: 0,
    res: 0,
    dex: 0,
    agi: 0,
    wis: 0,
    int: 0
  },

  {
    name: 'Soberano',
    value: 3,
    pv: 2,
    ph: 1,
    mov: 1,
    str: 1,
    res: 1,
    dex: 1,
    agi: 1,
    wis: 1,
    int: 1
  },

  {
    name: 'Lendário',
    value: 4,
    pv: 5,
    ph: 2,
    mov: 3,
    str: 3,
    res: 3,
    dex: 3,
    agi: 3,
    wis: 3,
    int: 3
  }
]
